import React from 'react';
import {
  bool, number, oneOfType, shape, string
} from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Price } from '@thd-olt-component-react/price';
import { Rating } from '@thd-olt-component-react/rating';
import { Image } from '@thd-olt-component-react/image';
import '../../../styles/hotspot-details.scss';

const HotspotDetails = ({ itemID, sku, storeId, channel }) => {

  const onProductLinkClick = () => {
    LIFE_CYCLE_EVENT_BUS.trigger('product-hotspots.product-link-click', { sku: itemID });
  };

  const getProductInfo = (container = {}) => {
    const { identifiers = {}, reviews = {}, media = {} } = container;
    const { ratingsReviews = {} } = reviews;
    const { averageRating, totalReviews } = ratingsReviews;
    const { brandName, productLabel, canonicalUrl } = identifiers;
    const { images = [] } = media;
    const [productImage] = images;
    return {
      averageRating,
      brandName,
      imageUrl: productImage?.url || '',
      productLabel,
      canonicalUrl,
      totalReviews,
    };
  };

  const isMobile = channel === 'mobile';

  const renderDetails = (skuContainer = {}, _anchorClass = '') => {
    const {
      averageRating,
      brandName,
      imageUrl,
      productLabel,
      canonicalUrl,
      totalReviews,
    } = getProductInfo(skuContainer);

    return (
      <a
        className={_anchorClass}
        href={canonicalUrl}
        onClick={onProductLinkClick}
        rel="noreferrer"
        target={isMobile ? '_self' : '_blank'}
        data-testid="tooltip-product"
      >
        <Row className="details__main-row">
          <Col className="details__left-column" fallback="6" nopadding>
            <Image
              alt="Product"
              className="details__product-image"
              src={imageUrl?.split('<SIZE>').join('300')}
              width="100"
              height="50"
            />
          </Col>
          <Col className="details__right-column" fallback="6">
            <Row>
              <span className="details__product-label">
                {productLabel}
              </span>
              {brandName && (
                <span className="details__brand">
                  by&nbsp;
                  <span className="details__brand--bold">
                    {brandName}
                  </span>
                </span>
              )}
            </Row>
            {totalReviews > 0 && (
              <Row className="details__rating">
                <Rating className="details__rating-stars" value={Number(averageRating)} />
                <span>({totalReviews})</span>
              </Row>
            )}
            <Row>
              <Price itemId={`${itemID}`} storeId={storeId} large={false} channel={channel} />
            </Row>
          </Col>
        </Row>
      </a>
    );
  };

  return renderDetails(sku);
};

HotspotDetails.propTypes = {
  apiKey: string.isRequired,
  itemID: string.isRequired,
  skip: bool.isRequired,
  sku: shape({
    identifiers: shape({
      brandName: string,
      canonicalUrl: string,
      productLabel: string
    }),
    canonicalUrl: string,
    reviews: shape({
      ratingsReviews: shape({
        averageRating: oneOfType([number, string]),
        totalReviews: oneOfType([number, string])
      })
    })
  }).isRequired,
  storeId: string.isRequired,
  channel: string.isRequired
};

export { HotspotDetails };
